import { ReactNode } from 'react'
import { FormWrapper, FormField, FormLine } from './styles'

export { FormField, FormLine }

interface IProps {
  children: ReactNode
}

const Form = (props: IProps) =>
  <FormWrapper>{props.children}</FormWrapper>

export default Form
